import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogTitle, TextField, Button } from '@mui/material'

function SubjectChangingDialog({handleClose, open,question, handleOk, subjects = []}) {
  console.log(subjects)
    const [subjectId, setSubjectId] = useState(-1)
    useEffect(() => {
      if(question.question.subjectId){
        setSubjectId(question.question.subjectId)
        // console.log("subject id " + question.question.subjectId)
      }
    }, [question])

    const _handleOk = () => {   
        handleOk(subjectId)
        handleClose()
    }
    

  return (
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Change Subject</DialogTitle>
        {
          subjects.length > 0 ? (subjects.map((sub, index)=>{
            return (
              <Button key={index} variant="outlined" color="primary" size="small" onClick={() => {
                setSubjectId(sub.id)
              }}>
                {`${sub.name} - ${sub.subjectGrade.nameTags[0].name}`}
              </Button>
            )
          })) : (<TextField label="Subject id" variant="filled" value={subjectId} onChange={e => setSubjectId(e.target.value)}/>)
        }
        

        <DialogActions>
        <Button autoFocus onClick={handleClose} variant='contained'>
          Cancel
        </Button>
        <Button onClick={_handleOk} variant='contained'>Change Subject</Button>
      </DialogActions>
      </Dialog>
  )
}

export default SubjectChangingDialog